/**
 * webfont 的生成规则
 */
export default function generateFontFamilyForWebfont(id: string): string {
  return `webfont_${id}`;
}
